import React from 'react'

import ProtectedRoute from '../../internal/ProtectedRoute'
import { Authorities } from '../../models/authorities'
import Home from './Home'

const HomeRoutes = () => (
  <ProtectedRoute
    key="/"
    path="/"
    exact
    authority={Authorities.PAY_APPLY}
    page={<Home />}
  />
)

export default HomeRoutes
